class BaoHeaderDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.addEventListener('click', this.handleClick.bind(this));

    window.addEventListener('mobile-nav-drawer:ui:close', this.closeDrawer.bind(this))
  }

  handleClick(event) {
    const customEvent = new CustomEvent('mobile-nav-drawer:ui:open');

    window.dispatchEvent(customEvent);
  }

  closeDrawer() {
    const drawer = document.querySelector('[data-bao-header-drawer-el="details"]')
    drawer.removeAttribute('open')
  }
}

customElements.define('bao-header-drawer', BaoHeaderDrawer);
